import { createSlice } from '@reduxjs/toolkit';
import { Status } from '../../helpers/consts/status';
import {
  addAdmin,
  editAdmin,
  fetchAdmins,
  removeAdmin,
} from '../actions/admin-actions';

const initialState = {
  status: Status.IDLE,
  admins: [],
};

const adminSlice = createSlice({
  name: 'admin',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchAdmins.pending, (state, action) => {
        state.status = Status.LOADING;
      })
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        const data = action.payload;

        state.admins = data;
        state.status = Status.COMPLETED;
      })
      .addCase(fetchAdmins.rejected, (state, action) => {
        state.status = Status.FAILED;
      })
      .addCase(addAdmin.fulfilled, (state, action) => {
        const newAdmin = action.payload;

        state.admins.unshift(newAdmin);

        state.admins = state.admins.sort((a, b) => {
          return a.position - b.position;
        });
      })
      .addCase(removeAdmin.fulfilled, (state, action) => {
        const adminId = action.payload;

        state.admins = state.admins.filter((admin) => admin.id !== adminId);

      })
      .addCase(editAdmin.fulfilled, (state, action) => {
        const editAdmin = action.payload;

        const index = state.admins.findIndex(
          (admin) => admin.id === editAdmin.id
        );

        if (~index) {
          state.admins[index] = editAdmin;
        }
      });
  },
});

export const adminActions = adminSlice.actions;

export default adminSlice;
